export const VehicleOptionName = {
  AirCondition: 1,
  SunMoonRoof: 2,
  TiltSteering: 3,
  HeatedCooledSeats: 4,
  CruiseControl: 5,
  AutoHeadlights: 6,
  PushButtonStart: 7,
  ProximityKey: 8,
  KeylessEntry: 9,
  SteeringControls: 10,
  AlloyWheels: 11,
  Tint: 12,
  TrailerHitch: 13,
  WinterTires: 14,
  Spoiler: 15,
  CDPlayer: 16,
  AndroidAuto: 17,
  AppleCarPlay: 18,
  Bluetooth: 19,
  DvdEntertainment: 20,
  GPSNavigation: 21,
  PremiumSound: 22,
  SiriusXM: 23,
  PowerLocks: 24,
  PowerMirrors: 25,
  PowerSeats: 26,
  PowerDoors: 27,
  PowerTrunk: 28,
  ABSBrakes: 29,
  AntiTheftSecurity: 30,
  BackupCamera: 31,
  BackupSensors: 32,
  FogLights: 33,
  HeatedMirrors: 34,
  TractionControl: 35,
  LaneDeparture: 36,
  TPMS: 37,
}

export const NormalizedVehicleOptions = {
  1: 'A/C',
  2: 'Sun',
  3: 'Tilt Steering',
  4: 'Heated / CooledSeats',
  5: 'Cruise Control',
  6: 'Auto Headlights',
  7: 'Push Button Start',
  8: 'Proximity Key',
  9: 'Keyless Entry',
  10: 'Steering Controls',
  11: 'Alloy Wheels',
  12: 'Tint',
  13: 'Trailer Hitch',
  14: 'Winter Tires',
  15: 'Spoiler',
  16: 'CD Player',
  17: 'Android Auto',
  18: 'Apple CarPlay',
  19: 'Bluetooth',
  20: 'DVD / Entertainment',
  21: 'GPS / Navigation',
  22: 'Premium Sound',
  23: 'Sirius / XM',
  24: 'Power Locks',
  25: 'Power Mirrors',
  26: 'Power Seats',
  27: 'Power Doors',
  28: 'Power Trunk',
  29: 'ABS Brakes',
  30: 'Anti-theft / Security',
  31: 'Backup Camera',
  32: 'Backup Sensors',
  33: 'FogLights',
  34: 'Heated Mirrors',
  35: 'Traction Control',
  36: 'Lane Departure',
  37: 'TPMS',
}

export const VehicleOptionLabels = {
  1: 'Air Conditioning',
  2: 'Sun / Moonroof',
  3: 'Tilt Steering',
  4: 'Heated / Cooled Seats',
  5: 'Cruise Control',
  6: 'Auto Headlights',
  7: 'Push Button Start',
  8: 'Proximity Key',
  9: 'Keyless Entry',
  10: 'Steering Controls',
  11: 'Alloy Wheels',
  12: 'Tint',
  13: 'Trailer Hitch',
  14: 'Winter Tires',
  15: 'Spoiler',
  16: 'CD Player',
  17: 'Android Auto',
  18: 'Apple CarPlay',
  19: 'Bluetooth',
  20: 'DVD / Entertainment',
  21: 'GPS / Navigation',
  22: 'Premium Sound',
  23: 'Sirius / XM',
  24: 'Power Locks',
  25: 'Power Mirrors',
  26: 'Power Seats',
  27: 'Power Doors',
  28: 'Power Trunk',
  29: 'ABS Brakes',
  30: 'Anti-Theft / Security',
  31: 'Backup Camera',
  32: 'Backup Sensors',
  33: 'Fog Lights',
  34: 'Heated Mirrors',
  35: 'Traction Control',
  36: 'Lane Departure',
  37: 'Tire Pressure Monitoring',
}
